module.exports = __webpack_public_path__ + "media/images/web/home/index/what_is_nomiri-239088f030a12ecd1b112f9cd5192a68.webp";